import React, { useEffect, useState } from 'react'
import { api } from '~/services/api'

export default function GitHubCallback() {
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading')
  const [message, setMessage] = useState('')

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Extract the code from URL parameters
        const urlParams = new URLSearchParams(window.location.search)
        const code = urlParams.get('code')
        const error = urlParams.get('error')

        if (error) {
          throw new Error(`OAuth error: ${error}`)
        }

        if (!code) {
          throw new Error('No OAuth code received')
        }

        // Connect GitHub account using the code
        const result = await api.profile.github.connect(code)
        
        setStatus('success')
        setMessage(result.message)

        // Close the window/tab after a short delay
        setTimeout(() => {
          window.close()
        }, 2000)

      } catch (err) {
        console.error('GitHub connection failed:', err)
        
        setStatus('error')
        setMessage(err instanceof Error ? err.message : 'Failed to connect GitHub account')
        
        // Close the window/tab after showing error
        setTimeout(() => {
          window.close()
        }, 3000)
      }
    }

    handleCallback()
  }, [])

  return (
    <div className="min-h-screen bg-[#0a0d0f] flex items-center justify-center">
      <div className="text-center p-8">
        <div className="mb-4">
          {status === 'loading' && (
            <div className="inline-block w-8 h-8 border-2 border-white/20 border-t-white rounded-full animate-spin"></div>
          )}
          {status === 'success' && (
            <div className="w-16 h-16 mx-auto bg-green-500 rounded-full flex items-center justify-center">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M20 6L9 17L4 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
          )}
          {status === 'error' && (
            <div className="w-16 h-16 mx-auto bg-red-500 rounded-full flex items-center justify-center">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M18 6L6 18M6 6L18 18" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
          )}
        </div>
        
        <h1 className="text-xl font-semibold text-white mb-2">
          {status === 'loading' && 'Connecting GitHub...'}
          {status === 'success' && 'GitHub Connected!'}
          {status === 'error' && 'Connection Failed'}
        </h1>
        
        <p className="text-white/60 text-sm mb-4">
          {message}
        </p>
        
        <p className="text-white/40 text-xs">
          {status === 'loading' && 'Please wait while we connect your account...'}
          {status === 'success' && 'This window will close automatically.'}
          {status === 'error' && 'This window will close automatically.'}
        </p>
      </div>
    </div>
  )
}
